module.exports = __webpack_public_path__ + "static/media/16.e5116abc.gif";